(() => {
  if (window.bioriumBackorderGuardInstalled) return;
  window.bioriumBackorderGuardInstalled = true;

  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';
  let frame = null;
  const observed = new WeakSet();

  function state() {
    return document.querySelector('[data-biorium-cart-scope="page"]') ||
      document.querySelector('[data-biorium-cart-scope="drawer"]');
  }

  function sync() {
    frame = null;
    const current = state();
    const blocked = current?.dataset.bioriumCartBlocked === 'true';
    const hasBackorder = current?.dataset.bioriumHasBackorder === 'true';
    document.querySelectorAll(checkoutSelector).forEach((button) => {
      if (blocked && !button.disabled) {
        button.disabled = true;
        button.dataset.bioriumDisabled = 'true';
      } else if (!blocked && button.dataset.bioriumDisabled === 'true') {
        if (current && Number(current.dataset.bioriumCartCount) > 0) button.disabled = false;
        delete button.dataset.bioriumDisabled;
      }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((buttons) => {
      if (hasBackorder && !buttons.hidden) {
        buttons.hidden = true;
        buttons.dataset.bioriumHidden = 'true';
      } else if (!hasBackorder && buttons.dataset.bioriumHidden === 'true') {
        buttons.hidden = false;
        delete buttons.dataset.bioriumHidden;
      }
    });
  }

  function scheduleSync() {
    if (frame === null) frame = requestAnimationFrame(sync);
  }

  function blockCheckout(event) {
    const current = state();
    if (current?.dataset.bioriumCartBlocked !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    current.querySelector('[data-biorium-cart-error]')?.focus();
  }

  function checkoutLink(element) {
    const link = element.closest('a[href]');
    if (!link) return false;
    try {
      const url = new URL(link.href, window.location.origin);
      return url.origin === window.location.origin && /\/checkout\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest(checkoutSelector) || checkoutLink(event.target)) blockCheckout(event);
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.name === 'checkout' || (!submitter && ['cart', 'CartDrawer-Form'].includes(event.target.id))) {
      blockCheckout(event);
    }
  }, true);

  function observeCart() {
    document.querySelectorAll('#main-cart-footer, cart-drawer').forEach((root) => {
      if (observed.has(root)) return;
      observed.add(root);
      new MutationObserver(scheduleSync).observe(root, { childList: true, subtree: true });
    });
    scheduleSync();
  }

  document.addEventListener('shopify:section:load', observeCart);
  observeCart();
})();
